// extracted by mini-css-extract-plugin
export default {"statisticItem":"StatisticItem_statisticItem__VcH0K","name":"StatisticItem_name__l6Xya"};